import { Injectable } from '@angular/core';
import {
  MonetizationApiModel,
  Subscription,
  SubscriptionPlan,
  SubscriptionStatus,
} from './monetization.model';
import { Observable, forkJoin, of } from 'rxjs';
import { DemoDeviceSerials } from '../../../../app/@store/demo-settings/demo-settings.model';
import dayjs from 'dayjs';
import { DemoSettingsStore } from '../../../../app/@store/demo-settings/demo-settings.store';
import { concatMap, map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MonetizationMockApi implements MonetizationApiModel {
  constructor(private demoSettingsStore: DemoSettingsStore) {}

  getVitoguideSubscriptions(_companyId?: string): Observable<Subscription[]> {
    return of([
      {
        boilerId: DemoDeviceSerials.Vitodens300 as string,
        expirationDate: dayjs().add(1, 'day').toDate(),
        hardwareBundle: null,
        id: 1,
        plan: SubscriptionPlan.Pro,
        status: SubscriptionStatus.active,
        subscriptionDate: dayjs().subtract(1, 'day').toDate(),
        subscribedBy: '23d329b3-748f-4be6-b7c8-8590a15d8367',
        subscribedByName: 'Jaxx Zi',
        trial: false,
      },
      {
        boilerId: DemoDeviceSerials.Vitocal200 as string,
        expirationDate: dayjs().add(1, 'day').toDate(),
        hardwareBundle: null,
        id: 2,
        plan: SubscriptionPlan.Pro,
        status: SubscriptionStatus.active,
        subscriptionDate: dayjs().subtract(1, 'day').toDate(),
        subscribedBy: '23d329b3-748f-4be6-b7c8-8590a15d8367',
        subscribedByName: 'Jaxx Zi',
        trial: false,
      },
      {
        boilerId: DemoDeviceSerials.Vitodens100opentherm as string,
        expirationDate: dayjs().add(1, 'day').toDate(),
        hardwareBundle: null,
        id: 3,
        plan: SubscriptionPlan.Plus,
        status: SubscriptionStatus.active,
        subscriptionDate: dayjs().subtract(1, 'day').toDate(),
        subscribedBy: '23d329b3-748f-4be6-b7c8-8590a15d8367',
        subscribedByName: 'Jaxx Zi',
        trial: false,
      },
      {
        boilerId: DemoDeviceSerials.Vitovalor as string,
        expirationDate: dayjs().add(1, 'day').toDate(),
        hardwareBundle: null,
        id: 4,
        plan: SubscriptionPlan.Pro,
        status: SubscriptionStatus.active,
        subscriptionDate: dayjs().subtract(1, 'day').toDate(),
        subscribedBy: '23d329b3-748f-4be6-b7c8-8590a15d8367',
        subscribedByName: 'Jaxx Zi',
        trial: false,
      },
      {
        boilerId: DemoDeviceSerials.Vitocharge as string,
        expirationDate: dayjs().add(1, 'day').toDate(),
        hardwareBundle: null,
        id: 5,
        plan: SubscriptionPlan.Pro,
        status: SubscriptionStatus.active,
        subscriptionDate: dayjs().subtract(1, 'day').toDate(),
        subscribedBy: '23d329b3-748f-4be6-b7c8-8590a15d8367',
        subscribedByName: 'Jaxx Zi',
        trial: false,
      },
      {
        boilerId: DemoDeviceSerials.VitoairFS as string,
        expirationDate: dayjs().add(1, 'day').toDate(),
        hardwareBundle: null,
        id: 6,
        plan: SubscriptionPlan.Pro,
        status: SubscriptionStatus.active,
        subscriptionDate: dayjs().subtract(1, 'day').toDate(),
        subscribedBy: '23d329b3-748f-4be6-b7c8-8590a15d8367',
        subscribedByName: 'Jaxx Zi',
        trial: false,
      },
      {
        boilerId: DemoDeviceSerials.Vitocal222 as string,
        expirationDate: dayjs().add(1, 'day').toDate(),
        hardwareBundle: null,
        id: 7,
        plan: SubscriptionPlan.Pro,
        status: SubscriptionStatus.active,
        subscriptionDate: dayjs().subtract(1, 'day').toDate(),
        subscribedBy: '23d329b3-748f-4be6-b7c8-8590a15d8367',
        subscribedByName: 'Jaxx Zi',
        trial: false,
      },
      {
        boilerId: DemoDeviceSerials.Vitocal252a as string,
        expirationDate: dayjs().add(1, 'day').toDate(),
        hardwareBundle: null,
        id: 8,
        plan: SubscriptionPlan.Pro,
        status: SubscriptionStatus.active,
        subscriptionDate: dayjs().subtract(1, 'day').toDate(),
        subscribedBy: '23d329b3-748f-4be6-b7c8-8590a15d8367',
        subscribedByName: 'Jaxx Zi',
        trial: false,
      },
      {
        boilerId: DemoDeviceSerials.Vitocal252MPK as string,
        expirationDate: dayjs().add(1, 'day').toDate(),
        hardwareBundle: null,
        id: 3,
        plan: SubscriptionPlan.Plus,
        status: SubscriptionStatus.active,
        subscriptionDate: dayjs().subtract(1, 'day').toDate(),
        subscribedBy: '23d329b3-748f-4be6-b7c8-8590a15d8367',
        subscribedByName: 'Jaxx Zi',
        trial: false,
      },
    ]).pipe(
      concatMap((monetizationObject) =>
        forkJoin(
          monetizationObject.map((obj) =>
            this.demoSettingsStore.selectCurrentPlan(obj.boilerId).pipe(take(1))
          )
        ).pipe(
          map((plans) => monetizationObject.map((obj, index) => ({ ...obj, plan: plans[index] })))
        )
      )
    );
  }
}
